import { useTranslation } from 'react-i18next'

import FacebookIcon from '@wwt/shared/assets/icons/logos/facebook.svg'
import InstagramIcon from '@wwt/shared/assets/icons/logos/instagram.svg'
import MessengerIcon from '@wwt/shared/assets/icons/logos/messenger.svg'
import WhatsAppIcon from '@wwt/shared/assets/icons/logos/whatsapp.svg'
import ShareIcon from '@wwt/shared/assets/icons/outline/share.svg'

import { NestedMenuContent, NestedMenuItem } from '@/shared/ui/NestedMenu'

import { useShare } from '../lib/useShare'
import { CopyLinkItem } from './ShareOptions/CopyLink'
import { MoreOptionsItem } from './ShareOptions/MoreOptions'

export const ShareMenu = () => {
	const { t } = useTranslation('header')

	const {
		handleMessengerShare,
		handleInstagramShare,
		handleWhatsappShare,
		handleFacebookShare
	} = useShare()

	return (
		<>
			<NestedMenuItem
				to="share"
				data-wwt-id="header__burger-share--button"
			>
				<ShareIcon />
				{t('share.menu.share')}
			</NestedMenuItem>
			<NestedMenuContent path="share">
				<CopyLinkItem />
				<NestedMenuItem
					data-wwt-id="header__burger-share-messenger--link"
					onClick={handleMessengerShare}
				>
					<MessengerIcon />
					{t('share.options.messenger')}
				</NestedMenuItem>
				<NestedMenuItem
					data-wwt-id="header__burger-share-instagram--link"
					onClick={handleInstagramShare}
				>
					<InstagramIcon />
					{t('share.options.instagram')}
				</NestedMenuItem>
				<NestedMenuItem
					data-wwt-id="header__burger-share-whatsapp--link"
					onClick={handleWhatsappShare}
				>
					<WhatsAppIcon />
					{t('share.options.whatsapp')}
				</NestedMenuItem>
				<NestedMenuItem
					data-wwt-id="header__burger-share-facebook--link"
					onClick={handleFacebookShare}
				>
					<FacebookIcon />
					{t('share.options.facebook')}
				</NestedMenuItem>
				<MoreOptionsItem />
			</NestedMenuContent>
		</>
	)
}
